import { render, staticRenderFns } from "./toggleSwitch.vue?vue&type=template&id=0f8d60b5&scoped=true&"
import script from "./toggleSwitch.vue?vue&type=script&lang=js&"
export * from "./toggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./toggleSwitch.vue?vue&type=style&index=0&id=0f8d60b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d60b5",
  null
  
)

export default component.exports